export default __webpack_public_path__ + "static/media/delta2026.95d8c799.jpeg";